import { LoyaltyAcmTypeService } from './../../../services/loyalty/loyalty-acm-type.service';
import { SelectItem } from 'primeng/components/common/api';
import { LoyaltyChannelService } from './../../../services/loyalty/loyalty-channel.service';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-accumulators',
  templateUrl: './campaign-accumulators.component.html',
  styleUrls: ['./campaign-accumulators.component.css']
})
export class CampaignAccumulatorsComponent implements OnInit {
  messageInstanceId: string;
  acmList: any[] = [];
  dateFilter = KontableComponent.DateFilter;
  selectFilter = KontableComponent.SelectFilter;
  showAddEditDialog = false;
  acmToEdit: any;
  dialogTitle: string;
  channelList: SelectItem[] = [{label: '', value: null}];
  acmTypeList: SelectItem[] = [{label: '', value: null}];
  operationTypeList: SelectItem[];
  acmScopeList: SelectItem[];
  messageInstance: any;
  actionStartDate: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private campaignService: Campaign2Service,
    private translateService: TranslateService,
    private loyaltyChannelService: LoyaltyChannelService,
    private loyaltyAcmTypeService: LoyaltyAcmTypeService,
    private router: Router
  ) { }

  ngOnInit() {
    this.messageInstanceId = this.activatedRoute.snapshot.params['messageInstanceId'];
    this.campaignService.getMessageInstance(+this.messageInstanceId).subscribe(res => {
      this.messageInstance = res[0];
      this.campaignService.getCampaignActionById(this.messageInstance.campaign_id, this.messageInstance.campaign_action_id).subscribe(res => {
        this.actionStartDate = res[0]['start_date'];
      });
    });
    this.getCampaignAcmList();
    this.loyaltyChannelService.getAllChannels().subscribe(res => {
      res.forEach(channel => this.channelList.push({label: channel.channel_code + ' - ' +channel.description  , value: channel.id}));
    });
    this.loyaltyAcmTypeService.getAllAcmTypes().subscribe(res => {
      res.forEach(acmType => this.acmTypeList.push({label: acmType.description, value: acmType.acm_type_code}));
    });
    this.operationTypeList = [
      {label: this.translateService.instant('acm.accumulation'), value: 'A'},
      {label: this.translateService.instant('acm.check'), value: 'C'},
    ];
    this.acmScopeList = [
      {label: '', value: null},
      {label: this.translateService.instant('campaign.emissionDates'), value: 'E'},
      {label: this.translateService.instant('campaign.fruition'), value: 'F'},
      {label: this.translateService.instant('campaign.both'), value: 'B'},
    ];
  }

  getCampaignAcmList() {
    this.campaignService.getCampaignAcmList(this.messageInstanceId).subscribe(res => this.acmList = res);
  }

  showDialog(acmData?: any) {
    this.acmToEdit = acmData || null;
    this.dialogTitle = acmData ? this.translateService.instant('acm.edit_title') : this.translateService.instant('acm.add_title');
    this.showAddEditDialog = true;
  }

  closeDialog() {
    this.showAddEditDialog = false;
  }

  saveAcm(acmData: any) {
    if (!!this.acmToEdit) {
      this.campaignService.updateAcm(acmData, this.acmToEdit.id).subscribe(() => {
        this.getCampaignAcmList();
        this.closeDialog();
      });
    } else {
      this.campaignService.createAcm(acmData).subscribe(() => {
        this.getCampaignAcmList();
        this.closeDialog();
      });
    }
  }

  deleteAcm(acm: any) {
    this.campaignService.deleteAcm(acm.id).subscribe(() => this.getCampaignAcmList());
  }

  goBack() {
    this.router.navigate([`campaign-coupon-parameters-setup/${this.messageInstanceId}`, {
      actionTypeCode: 'CPN'
    }]);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-accumulators/campaign-accumulators.component.ts